<div class="app__discovery--widget--container">
  <div class="app__itemCard-radioGroup app__sub-title items-start text-[#53565B] font-semibold mt-5 m-0 px-2">
    <p>
      Manage Sharing for
      <span class="font-weight-bold-blue" [matTooltip]="data?.form_name.length > 38 ? data.form_name : ''">
        {{ data?.form_name | truncateStrPipe : 38 }}
      </span>
    </p>
  </div>
  <div class="app__discovery--inner--section">
    <div class="app__discovery--options--box">
      <div class="app__between--justified--content flex-col sm:flex-row items-center">
        <p class="app__text-higlight flex items-center text-[#53565B] text-base">
          {{ stateObject?.first_name | capitalizeFirstWord }}'s Connections
          <!-- <span class="app__centered-item app__text-higlight w-[63px] h-[28px] bg-[#EBF0FA] rounded-[60px] text-[12px] ml-2">
          <span class="material-icons text-[12px] mr-1">add</span> Add</span
          > -->
          <span class="ml-2"><app-connection-modal (connectionCreated)="connectionCreated($event)"></app-connection-modal></span>
        </p>
        <div class="w-[240px] flex flex-col relative">
          <div class="app__discovery--box--search--field">
            <ng-container>
              <div class="app__centered-item w-full h-full justify-between bg-transparent overflow-y-hidden" aria-label="Search connections">
                <span class="material-icons text-k-blue"> search </span>
                <input class="w-[90%] border-none outline-none" [(ngModel)]="searchUser" type="text" placeholder="Search connections" />
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="app__discovery--options app__centered-item">
        @for (user of allConnections | filterWorkspace : searchUser; track user) {
          <span
            class="app__discovery--options--item"
            [matTooltip]="user?.name.length > 20 ? user.name : ''"
            matTooltipPosition="above"
            (click)="handleSelectedUser(user, 'user')"
            >
            <ngx-avatars
              class="custom-nx-avatar mr-2"
              size="24"
              [src]="user?.user_profile_image_url"
              [name]="user?.name | titlecase"
              [round]="false"
              initialsSize="2"
              cornerRadius="100"
            ></ngx-avatars>
            {{ user?.name | truncateStrPipe : 20 }}
          </span>
        }
      </div>
    </div>

    @if (selectedUsers.length) {
      <div class="mt-8">
        <p class="app__centered-item justify-start text-base text-[#898F9E] font-semibold">
          Shared
          <span class="text-[#25508E] font-bold ml-1"> ({{ selectedUsers.length }}) </span>
        </p>
        <div class="flex flex-wrap gap-3 sm:pb-0 pb-28">
          @for (user of selectedUsers; track user) {
            <span class="app__discovery--selected--option paragraph__medium">
              <ngx-avatars
                class="custom-nx-avatar"
                size="40"
                [src]="user?.user_profile_image_url"
                [name]="user?.name | titlecase"
                [round]="true"
                initialsSize="2"
                cornerRadius="100"
              ></ngx-avatars>
              <span class="w-[80%] text-start block mt-[18px]" [matTooltip]="user?.name.length > 24 ? user.name : ''" matTooltipPosition="above">
                <p class="text-sm">{{ user?.name | truncateStrPipe : 36 }}</p>
                <p class="font-medium text-[12px] text-[#707070] mt-[-12px]">{{ user?.relationship_name ?? 'Legal Entity' }}</p>
              </span>
              <div class="app__centered-item justify-end">
                <span class="app__centered-item mr-5">
                  <span class="app__form--attribute--sub--title text-[#515765] font-medium text-center leading-4 mr-2"> Notifications </span>
                  <mat-slide-toggle
                    class="w-8 rounded-[50%]"
                    [checked]="user.vault_user_share_is_sealed"
                    (click)="$event.preventDefault(); handleNotificationBell(user)"
                    ></mat-slide-toggle
                  ></span>
                  <span
                    class="app__centered-item w-8 h-8 rounded-[50%] bg-[#EB57571F] text-[#EB5757] hover:cursor-pointer"
                    (click)="deleteUserSharedWith(user)"
                    >
                    <img src="/assets/images/trash-2.svg" alt="" class="w-4 h-4" />
                  </span>
                </div>
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
  <div class="app__between--justified--content w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
    <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
      <span class="app__centered-item gap-2 text-[#18191C]"
        ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
        >
      </button>
      <div class="w-[158px]">
        <button
          class="app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
          type="submit"
          (click)="handleSteps('forward')"
          >
          Continue
        </button>
      </div>
    </div>
